import { YES_AND_NO_TYPES } from '@btime/constants'
import { length, pipe } from 'ramda'

const incrementIf =
  (key, condition, amount = 1) =>
  obj => {
    if (!condition) return obj
    return { ...obj, [key]: (obj[key] || 0) + amount }
  }

export const countReplies = replies => {
  return replies.reduce((counterObj, reply) => {
    const { value, question } = reply
    const type = question?.type?.name

    return pipe(
      incrementIf('actionPlansCount', type === 'action_plan', length(value || [])),
      incrementIf('affirmativeCount', YES_AND_NO_TYPES.includes(type) && value === true),
      incrementIf('negativeCount', YES_AND_NO_TYPES.includes(type) && value === false),
      incrementIf('naCount', YES_AND_NO_TYPES.includes(type) && value === null),
      incrementIf('nonCompliancesCount', reply.isNonCompliance),
      incrementIf('total', true)
    )(counterObj)
  }, {})
}
